/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { axiosInstance } from '../axiosInstance'

export const getAllSplunk = param => {
    return axiosInstance.post(`/api/gcadmin/v1/splunk-record/getAll`, param).then(res => res.data)
}
export const getSplunk = param => {
    return axiosInstance.post(`/api/gcadmin/v1/splunk-record/getRecord`, param).then(res => res.data)
}
export const getSplunkHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/splunk-record/get-history`, param).then(res => res.data)
}
export const getAllSplunkUsers = param => {
    return axiosInstance.post(`/api/gcadmin/v1/splunk/getUsers`, param).then(res => res.data)
}
export const deleteSplunkUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/splunk/deleteUser`, param).then(res => res.data)
}
export const createSplunkUser = param => {
    return axiosInstance.post(`/api/gcadmin/v1/splunk/createUser`, param).then(res => res.data)
}